import {StationMeta} from '../api/types';

/**
 * Apply sensor order and visibility from station.meta to a channel list.
 * Filters out hidden channels and reorders based on saved order.
 */
export const applySensorConfig = (
  channels: string[],
  sensorType: string,
  meta?: StationMeta,
): string[] => {
  if (!meta) return channels;

  const hiddenKeys = meta.sensor_hidden?.[sensorType] || [];
  const orderKeys = meta.sensor_order?.[sensorType];

  // Filter out hidden channels
  let result =
    hiddenKeys.length > 0
      ? channels.filter((ch) => !hiddenKeys.includes(ch))
      : channels;

  // Apply saved order
  if (orderKeys && orderKeys.length > 0) {
    const ordered = orderKeys.filter((key) => result.includes(key));
    const remaining = result.filter((ch) => !orderKeys.includes(ch));
    result = [...ordered, ...remaining];
  }

  return result;
};
